import darkLogo from "../assets/png/dark-logo.png"
import lightLogo from "../assets/png/light-logo.png"
import { classNames } from "utils/ClassNames"
import { resolveIsDark, useThemeStore } from "hooks/useTheme"

type Props = {
  width?: string | number
  height?: string | number
  className?: string
  onClick?: () => void
  style?: React.CSSProperties
}

export const LoversLiveForeverLogo = ({
  width = "300px",
  height = "auto",
  className = "",
  onClick,
  style
}: Props) => {
  const theme = useThemeStore((state) => state.theme)
  const isDark = resolveIsDark(theme)

  return (
    <>
      <img
        src={isDark ? lightLogo : darkLogo}
        width={width}
        height={height}
        onClick={onClick}
        style={style}
        className={classNames("dark:hidden", className)}
        alt="lovers live forever logo"
      />
      <img
        src={lightLogo}
        width={width}
        height={height}
        onClick={onClick}
        style={style}
        className={classNames("hidden dark:block", className)}
        alt="lovers live forever logo"
      />
    </>
  )
}
